var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow3RightDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#002A69",
    fillRule: "nonzero",
    d: "M19.5 18a1.5 1.5 0 0 1-1.5 1.5h-8a1.5 1.5 0 0 1 0-3h4.379L5.282 7.404a1.5 1.5 0 1 1 2.122-2.122L16.5 14.38V10a1.5 1.5 0 1 1 3 0v8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow3RightDown);
export default __webpack_public_path__ + "static/media/Arrow_3_right_down.b2dbbe8bfab38732446754271ef811c1.svg";
export { ForwardRef as ReactComponent };